<script setup lang="ts"></script>

<template>
  <article
    class="CardSkeleton flex animate-pulse flex-col rounded-lg border bg-white p-4 shadow-sm"
  >
    <div class="flex flex-1 flex-col justify-between space-y-4">
      <!-- Title -->
      <div class="flex h-6 w-32 rounded-md bg-gray-300" />

      <!-- Gray block with bank info -->
      <div class="flex items-center gap-2 rounded-lg bg-gray-100 p-4">
        <div class="h-10 w-10 shrink-0 rounded-lg border bg-gray-300 bg-white" />
        <div class="flex w-full flex-col gap-1.5">
          <div class="h-4 w-24 rounded-md bg-gray-300" />
          <div class="h-5 w-40 rounded-md bg-gray-300" />
          <div class="flex items-center gap-1">
            <div class="h-4 w-4 rounded-full bg-gray-300" />
            <div class="ml-1 h-3 w-6 rounded-md bg-gray-300" />
          </div>
        </div>
      </div>

      <!-- 4 columns: rate, monthly payment, overpayment, term -->
      <div class="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <div v-for="n in 4" :key="n">
          <div class="h-4 w-12 rounded-md bg-gray-300" />
          <div class="mt-1 h-6 w-20 rounded-md bg-gray-300" />
        </div>
      </div>

      <!-- Buttons -->
      <div class="flex flex-wrap gap-3">
        <div class="h-10 w-36 rounded-md bg-blue-200" />
      </div>
    </div>
  </article>
</template>
